/**
 * Constantes reutilizables de la aplicación
 * Centraliza valores mágicos y configuraciones
 */

/**
 * Tamaños de página estándar para paginación
 */
export const PAGE_SIZES = [5, 10, 20, 30, 50, 100] as const;

/**
 * Tamaño de página por defecto
 */
export const DEFAULT_PAGE_SIZE = 10;

/**
 * Ancho máximo estándar para contenedores
 */
export const MAX_CONTAINER_WIDTH = '1400px';

/**
 * Padding estándar para páginas
 */
export const PAGE_PADDING = '24px';

/**
 * Opciones de IVA comunes
 */
export const IVA_RATES = [
  { value: 0, label: '0%' },
  { value: 10.5, label: '10.5%' },
  { value: 21, label: '21%' },
  { value: 27, label: '27%' },
] as const;

/**
 * Tipos de comprobante disponibles
 */
export const TIPOS_COMPROBANTE = [
  { value: 'FC', label: 'Factura' },
  { value: 'RT', label: 'Recibo' },
] as const;

/**
 * Letras de comprobante disponibles
 */
export const LETRAS_COMPROBANTE = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'X', label: 'X' },
] as const;

/**
 * Formatos de fecha comunes
 */
export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
  API: 'YYYY-MM-DD',
  DATETIME_API: 'YYYY-MM-DDTHH:mm:ss',
} as const;

